import { queryOptions } from '@tanstack/react-query'

import type { BranchPage } from '@/bindings/BranchPage'
import type { RestaurantPage } from '@/bindings/RestaurantPage'
import { request } from '@/lib/api'

/** Public, session-less (H1); `my_role` rides along when the cookie is live. */
export const landingKeys = {
  restaurant: (restaurantSlug: string) => ['public', 'restaurant', restaurantSlug] as const,
  branch: (restaurantSlug: string, branchSlug: string) => ['public', 'branch', restaurantSlug, branchSlug] as const,
}

/** `refetchOnMount: 'always'`: the cached page may predate a login, and `my_role` is per caller. */
export function restaurantPageQuery(restaurantSlug: string) {
  return queryOptions({
    queryKey: landingKeys.restaurant(restaurantSlug),
    queryFn: () => request<RestaurantPage>(`/public/${encodeURIComponent(restaurantSlug)}`),
    refetchOnMount: 'always',
  })
}

export function branchPageQuery(restaurantSlug: string, branchSlug: string) {
  return queryOptions({
    queryKey: landingKeys.branch(restaurantSlug, branchSlug),
    queryFn: () => request<BranchPage>(`/public/${encodeURIComponent(restaurantSlug)}/${encodeURIComponent(branchSlug)}`),
    refetchOnMount: 'always',
  })
}

/** The public URL shapes (URL scheme 2026-09-01): printed QRs carry these two. */
export function restaurantPath(restaurantSlug: string) {
  return `/${restaurantSlug}`
}

export function branchPath(restaurantSlug: string, branchSlug: string) {
  return `/${restaurantSlug}/${branchSlug}`
}
